var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew236({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-linecap:square;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.56,9.46h-.64L10.87,7.21l-.31-.72v3h-.45V5.85h.63l1,2.13.36.83v-3h.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.58,8.31a1.14,1.14,0,0,1-.11.49,1.44,1.44,0,0,1-.32.38,1.8,1.8,0,0,1-.48.24,1.93,1.93,0,0,1-.6.09h-.36l-.17,0-.16,0V9l.34.05h.39a1.25,1.25,0,0,0,.4-.05.71.71,0,0,0,.3-.15A.57.57,0,0,0,15,8.65a.74.74,0,0,0,.07-.31.53.53,0,0,0-.25-.49,1.31,1.31,0,0,0-.69-.15h-.69V5.85h2v.42H13.9v1h.31a2.84,2.84,0,0,1,.51,0,1.3,1.3,0,0,1,.44.17.92.92,0,0,1,.31.31A1.06,1.06,0,0,1,15.58,8.31Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.97,
    y: 5.34,
    width: 7.88,
    height: 4.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew236);
export default __webpack_public_path__ + "static/media/Symbolpack_New_236.2458561edaf66140b79abd94ff2ebe2f.svg";
export { ForwardRef as ReactComponent };